// extracted by mini-css-extract-plugin
module.exports = {"mapOfNigeria":"MapOfNigeria-module--mapOfNigeria--2JyZm"};